function waitForElement(selector, timeout = 10000) {
  return new Promise((resolve, reject) => {
    const existingElement = document.querySelector(selector);
    if (existingElement) {
      return resolve(existingElement);
    }

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect();
        resolve(el);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    if (timeout) {
      setTimeout(() => {
        observer.disconnect();
        reject(new Error(`Elemento ${selector} no apareció después de ${timeout}ms`));
      }, timeout);
    }
  });
}

class ProductGallery extends HTMLElement {
 constructor() {
  super();
 }
}
customElements.define(`product-gallery`,ProductGallery);

class MainProductForm extends HTMLElement {
  constructor() {
    super();
    this.descriptionQuerySelector = `.sls-selling-plan-group-options[data-interval-count="1"] .sls-selling-plan-group-price-per-delivery`;
  }

  async connectedCallback() {
    // Ya no movemos el bloque de la app.
    // Solo configuramos el listener para mover la descripción.
    await waitForElement(this.descriptionQuerySelector, 10000).then((el) => {
      this.setupSubscriptionListener();
    }).catch(err => {
      // Silenciar el error si el elemento no se encuentra (ej. producto sin suscripción)
    });
  }

  // Esta función crea un 'clone' de forma segura
  _moveDescriptionContent() {
    try {
      const source = this.querySelector(`#subscription_description`);
      const target = document.querySelector(this.descriptionQuerySelector);

      if (!source || !target) { return; }

      let clone = target.querySelector(`#subscription_description_clone`);
      if (!clone) {
        clone = document.createElement('div');
        clone.id = 'subscription_description_clone';
        target.appendChild(clone);
      }
      clone.innerHTML = source.innerHTML;
    } catch (e) {
      console.warn("No se pudo mover la descripción de suscripción:", e);
    }
  }

  // Se llama CADA VEZ que el usuario cambia de opción
  sellingPlanChanged() {
    this._moveDescriptionContent();
  }

  // Mueve la descripción en la carga inicial (después de 1s)
  setupSubscriptionListener() {
    setTimeout(() => {
      this._moveDescriptionContent(); 
      document.addEventListener(
        "sealsubs:selling_plan_changed",
        this.sellingPlanChanged.bind(this),
        false
      );
    }, 1000); // 1s de delay para esperar a que Seal Subs se renderice
  }
}
customElements.define(`main-product-form`, MainProductForm);


/* Product Gallery - inicialización Swiper (main + thumbs) */
/* (Este código no se toca, está bien) */
(function () {
  function waitForSwiper(callback) {
    if (typeof window.Swiper !== 'undefined') {
      callback();
      return;
    }
    const observer = new MutationObserver(() => {
      if (typeof window.Swiper !== 'undefined') {
        observer.disconnect();
        callback();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    const interval = setInterval(() => {
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(interval);
        observer.disconnect();
        callback();
      }
    }, 100);
  }

  function initOne(root) {
    if (!root || root.__pgInit) return;
    root.__pgInit = true;

    var mainEl   = root.querySelector('[data-pg-main]');
    var thumbsEl = root.querySelector('[data-pg-thumbs]');
    var prevEl   = root.querySelector('[data-pg-prev]');
    var nextEl   = root.querySelector('[data-pg-next]');

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

    const commonFixes = {
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      touchStartPreventDefault: false,
      passiveListeners: false,
      grabCursor: !isIOS,
    };

    var thumbs = new window.Swiper(thumbsEl, {
      ...commonFixes,
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      grabCursor: true,
      a11y: { enabled: true },
      breakpoints: {
        750: { spaceBetween: 10 }
      }
    });

    var main = new window.Swiper(mainEl, {
      ...commonFixes,
      spaceBetween: 0,
      slidesPerView: 1,
      effect: 'slide',
      navigation: { prevEl, nextEl },
      a11y: { enabled: true },
      thumbs: { swiper: thumbs }
    });

    main.on('slideChange', function () {
      var activeThumb = thumbsEl.querySelector('.swiper-slide-thumb-active');
      if (activeThumb) activeThumb.setAttribute('aria-current', 'true');
      thumbsEl.querySelectorAll('.swiper-slide').forEach(el => {
        if (el !== activeThumb) el.removeAttribute('aria-current');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pg-root]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForSwiper(initAll));
  } else {
    waitForSwiper(initAll);
  }

  document.addEventListener('shopify:section:load', () => waitForSwiper(initAll));
  document.addEventListener('shopify:section:reorder', () => waitForSwiper(initAll));
})();